const templateModule = {
  title: 'Modelos',
  new: 'Criar Modelo',
  newAi: 'Modelo Inteligente',
  key: 'Chave',
  words: {
    here: 'aqui',
  },
  alert: {
    text: 'Crie e gerencie modelos de documentos que podem ser preenchidos por fluxos ou integrações via API.',
    action: 'Ver documentação',
  },
  status: {
    created: 'Carregando...',
    published: '@:templateModule.status.created',
    failed: {
      unknown: 'error',
      formatInvalid: 'Formato inválido',

      reason: {
        incorrectImageTag:
          'A tag: "{tag}" no seu modelo está incorreta. Certifique-se de que a tag de "imagem" esteja em letras minúsculas. Exemplo: "[imagem] variavel".',
        unopenedTag: 'Variável aberta incorretamente, faltando chaves no início. Ex.: {tag}}}',
        unclosedTag: 'Variável fechada incorretamente, faltando chaves no final. Ex.: {tag}',
        undefined:
          'O formato do arquivo pode não estar em .docx ou podem haver erros nas variáveis',
      },
    },
  },
  list: {
    invalidWarning: 'Há modelos inválidos na lista. Verifique como corrigir {0}.',
    pendingTemplatetesWarning:
      'Processando últimos modelos. Aguarde para visualizá-los nesta lista',
    loading: 'Carregando lista de modelos...',
    empty: 'Crie seu modelo para que a Clicksign gere seus documentos automaticamente',
    keyHelp: 'Chave para geração de documentos via API.',
    actions: {
      generate: 'Gerar documento',
      options: 'Opções',
    },
    emptyFlow: 'Selecione este modelo em um {0} ou {1} para criar um processo automatizado.',
    formFlow: 'fluxo com formulário',
    spreadsheetFlow: 'fluxo com planilha',
    searchField: 'Busque pelo nome do modelo',
    tabs: {
      templates: 'Seus modelos',
      examples: 'Exemplos',
    },
    examples: {
      alert:
        'Os documentos de Exemplos servem como um material consultivo para a criação dos seus fluxos.',
      viewTemplate: 'Visualizar modelo',
      exampleList: {
        tuitionAgreement: {
          title: 'Contrato de Custeio de Serviço Educacional',
          description:
            'Documento contratual que formaliza o compromisso financeiro entre o aluno ou responsável do aluno e a instituição de ensino para custear os serviços educacionais prestados, detalhando valores, prazos, formas de pagamento e condições de rescisão.',
        },
        beneficiaryNomination: {
          title: 'Termo de Nomeação de Beneficiário',
          description:
            'Documento utilizado para formalizar a indicação ou alteração dos beneficiários de um contrato de seguro, especificando a porcentagem de participação de cada um e seu grau de parentesco com o segurado.',
        },
        realEstateRepresentation: {
          title: 'Contrato de Representação Comercial Imobiliária',
          description:
            'Contrato de representação comercial voltado ao segmento Imobiliário, especialmente para formalizar a relação entre corretores autônomos e imobiliárias.',
        },
        portabilityTerm: {
          title: 'Termo de Portabilidade',
          description:
            'Documento que formaliza o pedido do cliente para transferir sua operação de crédito (como empréstimos ou financiamentos) de uma instituição financeira para outra, contendo dados pessoais, informações sobre a operação a ser portada e declarações de ciência e autorização.',
        },
        serviceAgreement: {
          title: 'Contrato de Prestação de Serviços',
          description:
            'Documento que formaliza a contratação de uma parte (prestador) para executar serviços específicos em favor de outra (contratante), definindo obrigações, prazos, formas de pagamento, responsabilidades e condições de rescisão.',
        },
        residentialLease: {
          title: 'Contrato de Locação de Imóvel Residencial',
          description:
            'Documento que estabelece os termos da cessão do uso de um imóvel residencial pelo locador (proprietário) ao locatário (inquilino), mediante pagamento de aluguel, detalhando cláusulas como valor, prazo, reajustes, garantias, deveres das partes e condições de uso e devolução do imóvel.',
        },
      },
    },
  },
  notification: {
    success: {
      destroy: 'Modelo {name} excluído com sucesso.',
    },
    error: {
      destroy: 'Falha ao excluir modelo.',
    },
  },
  merge: {
    title: 'Gerar documento',
    info: 'Crie um documento e envie para assinatura.',
    fileNameLabel: 'Nome do documento que será gerado',
    fileNameTip:
      "Para que o documento seja criado dentro de uma pasta, basta inserir o nome da pasta neste campo. Por exemplo, '/pasta 1/pasta 2/contrato 123.docx'.",
    templateText: 'Adicione as variáveis do documento no formato json',
    action: 'Gerar',
    errors: {
      generic: 'Ocorreu um erro ao gerar o documento. Por favor, tente novamente mais tarde.',
    },
  },
  modalPrivacy: {
    title: 'Definir permissões de acesso do modelo ',
    selectAccessType: {
      label: 'Selecione o tipo de acesso do modelo',
      public: 'Acesso para todos os usuários da conta',
      private: 'Acesso apenas para usuários selecionados',
    },
    selectGroupsLabel: 'Selecione os grupos que terão acesso ao modelo',
    selectMembers: {
      label: 'Selecione os usuários que terão acesso ao modelo',
      admin: 'Administrador',
      adminInfo: 'Administradores da conta sempre terão acesso por padrão',
    },
    notification: {
      updated: 'Definições de permissões atualizadas com sucesso.',
      error: 'Não foi possível atualizar as definições de permissões',
    },
  },
  modalDelete: {
    title: 'Excluir modelo?',
    description: 'Tem certeza que deseja excluir este modelo?',
  },
};

export default templateModule;
